module.exports = __webpack_public_path__ + "img/baka.857b1f75.svg";